import React from 'react';
import StarRating from './StarRating';
import Avatar from './Avatar';

export default function VerbatimQuote({ text, author, rating, photoUrl }) {
  if (!text) return null;
  const showAuthor = author || (typeof rating === 'number' && rating > 0);

  return (
    <blockquote style={styles.quote}>
      <p style={styles.text}>« {text} »</p>
      {showAuthor && (
        <footer style={styles.footer}>
          {author && <Avatar name={author} photoUrl={photoUrl} size={20} />}
          {author && <span style={styles.authorName}>{author}</span>}
          {typeof rating === 'number' && rating > 0 && <StarRating rating={rating} size={11} />}
        </footer>
      )}
    </blockquote>
  );
}

const styles = {
  quote: {
    margin: 0,
    padding: 12,
    background: '#FFF5F0',
    borderLeft: '3px solid #E8502A',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  text: {
    margin: 0,
    fontSize: 13,
    color: '#1A1A1A',
    lineHeight: 1.5,
    fontStyle: 'italic',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    color: '#6B6B6B',
  },
  authorName: {
    fontWeight: 600,
    color: '#1A1A1A',
  },
};
